<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'consultationAdd',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-consultation-dialog'" :title="state.dialog.title" :width="state.dialog.width"
    :confirm-loading="state.loading.submit" :ok-text="state.dialog.submitTxt" @ok="onSubmit" @cancel="closeDialog"
    :closable="false" :maskClosable="false">
    <div class="form-content">

      <a-form ref="formRef" :model="state.ruleForm" :rules="state.rules" :label-col="{ style: 'width: 80px' }"
        :wrapper-col="{ style: 'flex: 1' }" class="consultation-form">
        <a-form-item label="门店名称" name="storeId">
          <a-select v-model:value="state.ruleForm.storeId" placeholder="请选择门店" allow-clear>
            <a-select-option v-for="item in storeList" :key="item.id" :value="item.id" :label="item.storeName">
              {{ item.storeName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="用户">
          <a-input disabled :value="selectedUserNickname" :placeholder="state.ruleForm.storeId ? '' : '请先选择门店'" />
        </a-form-item>
        <a-form-item label="咨询分类" name="categoryCode">
          <a-select v-model:value="state.ruleForm.categoryCode" placeholder="请选择咨询分类" allow-clear>
            <a-select-option v-for="item in categoryList" :key="item.code" :value="item.code">{{ item.name
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="问题描述" name="problemDesc" class="problem-desc-item">
          <a-textarea v-model:value="state.ruleForm.problemDesc" placeholder="请输入问题描述" :rows="3" :maxlength="500"
            allow-clear show-count />
        </a-form-item>
        <a-form-item label="图片上传" class="upload-form-item">
          <a-upload v-model:file-list="fileList" :action="uploadUrl" :headers="uploadHeaders"
            :disabled="fileList.length >= 5" :before-upload="beforeUpload" list-type="picture-card"
            @preview="handlePreview" @change="handleChange" multiple>
            <template #itemRender="{ originNode, file, actions: { preview, remove } }">
              <template v-if="file.status === 'uploading'">
                <VNodeRender :vnode="originNode" />
              </template>
              <div v-else class="ant-upload-list-item-container">
                <div class="ant-upload-list-item ant-upload-list-item-done"
                  :class="{ 'ant-upload-list-item-image': isImageFile(file.name) }">
                  <div class="ant-upload-list-item-thumbnail">
                    <template v-if="isImageFile(file.name)">
                      <img :src="file.url || file.thumbUrl" :alt="file.name" />
                    </template>
                    <span v-else class="ant-upload-list-item-thumbnail-file">
                      <FileOutlined style="font-size: 28px" />
                      <span class="upload-item-name">{{ file.name }}</span>
                    </span>
                  </div>
                  <span class="ant-upload-list-item-actions">
                    <a v-if="isImageFile(file.name)" class="ant-upload-list-item-action" @click.stop="preview()"
                      title="查看">
                      <EyeOutlined />
                    </a>
                    <a class="ant-upload-list-item-action" :href="file.url || file.thumbUrl" :download="file.name"
                      title="下载">
                      <DownloadOutlined />
                    </a>
                    <a class="ant-upload-list-item-action" @click.stop="remove()" title="删除">
                      <DeleteOutlined />
                    </a>
                  </span>
                </div>
              </div>
            </template>
            <div v-if="fileList.length < 5">
              <plus-outlined />
              <div style="margin-top: 8px">上传</div>
            </div>
          </a-upload>
          <span class="upload-tip">最多上传5张图片，单个不超过10MB</span>
          <a-modal :open="previewVisible" :footer="null" @cancel="previewVisible = false">
            <img style="width: 100%" :src="previewImage" />
          </a-modal>
        </a-form-item>
      </a-form>
    </div>

  </ant-Modal>
</template>

<script setup lang="ts" name="consultationAdd">
import { reactive, ref, computed, nextTick } from 'vue'
import { message, Upload } from 'ant-design-vue'
import { PlusOutlined, FileOutlined, EyeOutlined, DownloadOutlined, DeleteOutlined } from '@ant-design/icons-vue'
import { cloneDeep } from 'lodash-es'
import { useConsultation } from '@/store/consultation/consultation'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from '@/utils/Storage'

const emit = defineEmits(['createUpdate'])

const props = defineProps<{
  storeList: any[]
  categoryList: any[]
  userList: any[]
}>()

const consultationStore = useConsultation()

const formRef = ref()

const INIT_RULE_FORM = {
  storeId: undefined as number | undefined,
  userId: undefined as string | number | undefined,
  categoryCode: undefined as string | undefined,
  problemDesc: ''
}

const state = reactive({
  loading: {
    submit: false
  },
  dialog: {
    visible: false,
    title: '新增咨询',
    submitTxt: '确认',
    width: '969px'
  },
  ruleForm: cloneDeep(INIT_RULE_FORM),
  rules: {
    storeId: [{ required: true, message: '请选择门店', trigger: 'change' }],
    categoryCode: [{ required: true, message: '请选择咨询分类', trigger: 'change' }],
    problemDesc: [{ required: true, message: '请输入问题描述', trigger: 'blur' }]
  }
})

const fileList = ref<any[]>([])
const previewVisible = ref(false)
const previewImage = ref('')

const VNodeRender = (props: { vnode: any }) => props.vnode

const uploadUrl = computed(() => {
  const base = (import.meta.env.VITE_PROXY || '').replace(/\/+$/, '')
  return base ? `${base}/console/file/uploadFile` : '/console/file/uploadFile'
})

const uploadHeaders = computed(() => {
  return {
    Authorization: storage.get(ACCESS_TOKEN) || ''
  }
})

const allowUploadMimeTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'application/zip',
  'application/x-zip-compressed',
  'application/x-rar-compressed'
]
const allowUploadExts = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'zip', 'rar']

const filterStoreOption = (input: string, option: any) => {
  return (
    String(option.label || '')
      .toLowerCase()
      .indexOf(input.toLowerCase()) >= 0
  )
}

const selectedStore = computed(() => {
  return props.storeList.find((s: any) => String(s.id) === String(state.ruleForm.storeId))
})

const selectedUserNickname = computed(() => {
  const store = selectedStore.value
  if (store?.users?.length) {
    const user = store.users[0]
    return user?.nickname || user?.tel || ''
  }
  const userId = state.ruleForm.userId
  if (!userId) return ''
  const u = props.userList.find((item: any) => String(item.id) === String(userId))
  return u?.nickname || u?.username || u?.tel || ''
})

const onStoreChange = (value: number | undefined) => {
  if (value) {
    const store = props.storeList.find((s: any) => String(s.id) === String(value))
    state.ruleForm.userId = store?.userIds?.[0] || store?.users?.[0]?.userId || undefined
  } else {
    state.ruleForm.userId = undefined
  }
}

const beforeUpload = (file: File) => {
  if (fileList.value.length >= 5) {
    message.error('最多上传5个文件')
    return Upload.LIST_IGNORE
  }
  const fileExt = file.name.split('.').pop()?.toLowerCase() || ''
  const isAllowType = file.type.startsWith('image/') || allowUploadMimeTypes.includes(file.type) || allowUploadExts.includes(fileExt)
  if (!isAllowType) {
    message.error('请上传图片或文件类型')
    return Upload.LIST_IGNORE
  }
  if (file.size / 1024 / 1024 > 10) {
    message.error('文件不能超过10MB')
    return Upload.LIST_IGNORE
  }
  // 临时限制：仅允许图片上传
  if (!file.type.startsWith('image/') && !['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico'].includes(fileExt)) {
    message.error('暂不支持文件上传，请上传图片')
    return Upload.LIST_IGNORE
  }
  return true
}

const isImageFile = (name: string) => {
  const ext = (name || '').split('.').pop()?.toLowerCase() || ''
  return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'ico'].includes(ext)
}

const handlePreview = (file: any) => {
  const url = file.url || file.response?.data?.url || file.thumbUrl
  if (isImageFile(file.name || '')) {
    previewImage.value = url
    previewVisible.value = true
  } else {
    window.open(url)
  }
}

const handleChange = (info: any) => {
  fileList.value = info.fileList
  if (info.file.status === 'done') {
    const res = info.file.response
    if (res && res.code === 200 && res.data) {
      message.success(`${info.file.name} 上传成功`)
    } else {
      message.error(res?.msg || `${info.file.name} 上传失败`)
      fileList.value = fileList.value.filter((f: any) => f.uid !== info.file.uid)
    }
  } else if (info.file.status === 'error') {
    const res = info.file.response
    message.error(res?.msg || `${info.file.name} 上传失败`)
    fileList.value = fileList.value.filter((f: any) => f.uid !== info.file.uid)
  }
}

const openDialog = () => {
  state.dialog.visible = true
  state.ruleForm = cloneDeep(INIT_RULE_FORM)
  fileList.value = []
  nextTick(() => {
    formRef.value?.clearValidate()
  })
}

const closeDialog = () => {
  state.dialog.visible = false
  state.ruleForm = cloneDeep(INIT_RULE_FORM)
  fileList.value = []
  state.loading.submit = false
}

const onSubmit = () => {
  formRef.value
    .validate()
    .then(async () => {
      state.loading.submit = true
      const imageUrls = fileList.value
        .filter((f: any) => f.status === 'done')
        .map((f: any) => {
          if (f.response && f.response.data) {
            return typeof f.response.data === 'string' ? f.response.data : f.response.data.url
          }
          return f.url
        })
        .filter(Boolean)
      const param = { ...cloneDeep(state.ruleForm), imageUrls }
      try {
        await consultationStore.createConsultation(param)
        state.loading.submit = false
        emit('createUpdate')
      } catch {
        state.loading.submit = false
      }
    })
    .catch(() => {
      state.loading.submit = false
    })
}

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
.form-content {
  padding: 30px 36px 22px 36px;
}

.ml10 {
  margin-left: 10px;
}

.consultation-form {
  :deep(.ant-form-item) {
    margin-bottom: 0;
    padding-bottom: 24px;
  }

  :deep(.ant-form-item-label) {
    margin-left: 0;
    margin-right: 5px;
    width: 80px;
    text-align: right;
    justify-content: flex-end;
    display: flex;
    align-items: center;
    height: 40px;
  }

  :deep(.ant-form-item-label > label) {
    font-size: 14px;
    line-height: 1;
    font-weight: 400;
  }

  :deep(.ant-input-affix-wrapper) {
    height: 40px;
    padding: 0 11px;
    border-radius: 4px;
    display: flex;
    align-items: center;
  }

  :deep(.ant-input-disabled) {
    height: 40px;
    border-color: #C5C5D3;
    border-radius: 4px;
  }

  :deep(.ant-select-selector) {
    height: 40px !important;
    display: flex;
    align-items: center;
    border-radius: 4px;
  }

  // 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
  :deep(.ant-input-affix-wrapper:not(:hover):not(.ant-input-affix-wrapper-focused)) {
    border-color: #C5C5D3;
  }

  // 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-select:not(.ant-select-disabled):not(.ant-select-focused) .ant-select-selector:not(:hover)) {
    border-color: #C5C5D3;
  }

  // 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
  :deep(textarea.ant-input:not(:hover):not(:focus)) {
    border-color: #C5C5D3;
  }

  //textarea样式====>
  :deep(.ant-input-affix-wrapper:has(textarea)) {
    height: auto !important;
    min-height: 40px;
  }

  :deep(textarea.ant-input) {
    min-height: 198px;
    resize: vertical;
    border-radius: 4px;
    padding: 8px 22px 8px 11px;
  }

  :deep(.problem-desc-item .ant-input-textarea) {
    position: relative;
    display: inline-block;
    width: 100%;

    &[data-count]::after {
      content: attr(data-count);
      position: absolute;
      right: 10px;
      bottom: 5px;
      z-index: 1;
      color: rgba(0, 0, 0, 0.45);
      font-size: 12px;
      pointer-events: none;
      background: #fff;
      padding-left: 4px;
      line-height: 1;
    }
  }

  :deep(.ant-input-data-count) {
    display: none;
  }

  // 仅 textarea 的清除图标需要固定到第一行，普通 a-input 保持默认 flex 布局避免 x 与 count 重叠
  :deep(.ant-input-textarea .ant-input-clear-icon) {
    position: absolute;
    top: 12px;
    right: 10px;
    bottom: auto;
    margin-top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    line-height: 1;
  }
}

//<====textarea样式

.upload-tip {
  display: block;
  color: #999;
  margin-top: 8px;
  font-size: 12px;
}

.upload-form-item :deep(.ant-upload-list-item) {
  border: 1px dashed #d9d9d9;
}

.upload-form-item :deep(.ant-upload-list-item-thumbnail-file) {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: rgba(0, 0, 0, 0.45);
  background: #fafafa;
}

.upload-item-name {
  display: block;
  font-size: 11px;
  word-break: break-all;
  padding: 4px 8px;
  line-height: 1.3;
  max-width: 88px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
